import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd'

import './DraggableComponentInList.css'

const DragableComponentInList = (props) => {
  const { icon, title, type, prefix_type, cat_type, onDragStart, onDragEnd } = props
  const [{isDragging}, drag] = useDrag({
    item: { type: type, prefix_type: prefix_type, cat_type: cat_type },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  })

  useEffect(() => {
    const param = {
      type: type
    }
    if ( isDragging ) {
      if (onDragStart) {
        onDragStart(param)
      }
    } else {
      if (onDragEnd) {
        onDragEnd(param)
      }
    }
  }, [isDragging])

  const componentStyle = {
    lineHeight: '24px',
    verticalAlign: 'middle',
    borderRadius: 7.5,
    boxShadow: '0px 0px 3px 1px lightgrey',
    padding: '2.5px 5px',
    marginBottom: 9,
    userSelect: 'none',
    cursor: 'move',
    transition: '0.15s',
    backgroundColor: isDragging ? '#1085c5' : 'transparent',
    color: isDragging ? 'white' : 'black',
    overflow: 'visible',
    wordBreak: 'break-all',
    // opacity: isDragging ? 0.5 : 1
    // fontWeight: 'bold',
  }

  const titleStyle = {
    display: 'inline-block',
    lineHeight: '25px',
    fontSize: 16,
    fontWeight: 'bold',
  }

  return (
    <li ref={drag} className="d-a-component component" style={componentStyle}>
      <span>
        {icon && icon}
      </span>
      <span>
        {title}
      </span>
      {/* <p style={titleStyle}> {title} </p> */}
    </li>
  )
}

export default DragableComponentInList